"use client";
// React
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation"; // For getting query params
import { AlignLeft } from "lucide-react";

// Utils
import { HeaderProps } from "@/interfaces";

// Components
import UserProfile from "./user-profile";
import { supabase } from "@/utils/supabase/client";

export default function Header({
  setMobileMenuOpen,
  user_email,
  description = "Let's checkout community bots that you can expand by adding and configuring commands.",
}: HeaderProps) {
  const searchParams = useSearchParams();
  const userIdFromQuery = searchParams.get("user_id");

  const [fetchedEmail, setFetchedEmail] = useState<string | null>(null);

  useEffect(() => {
    if (!userIdFromQuery) return;
    const fetchUserEmail = async () => {
      const { data: user, error } = await supabase
        .from("user_roles")
        .select("user_email")
        .eq("user_id", userIdFromQuery)
        .single();
      if (error) {
        console.error(`Error fetching user roles:, ${error}`);
      } else {
        setFetchedEmail(user?.user_email as string);
      }
    };

    fetchUserEmail();
  }, [userIdFromQuery]);

  return (
    <div className="flex flex-row justify-between items-start px-5 pt-6 md:py-6">
      <AlignLeft
        className="md:hidden h-6 w-6"
        onClick={() => setMobileMenuOpen(true)}
      />
      <div className="hidden md:block">
        <h1 className="text-foreground font-medium">
          Hi, {fetchedEmail || user_email}{" "}
        </h1>
        <p className="text-muted-foreground text-sm">{description}</p>
      </div>
      <div className="block md:hidden text-center">Talkument</div>
      <UserProfile />
    </div>
  );
}
